import React, { PureComponent } from 'react';
import './App.css';
import Quiz from './Components/Quiz'

class App extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      quizVisible: false,
      startQuiz: false,
      data: null,
    };
  }

  render() {
    const {
      params,
      questions
    } = this.props;

    console.log('PARAMS', params)

    //   < h1 className = 'end-text' > { buttonText.end } { score } out of { questions.length }.</h1 >
    // <h1 className='end-msg'> {msg}</h1>
    // <h1 className='end-msg'> {buttonText.endBtn} <a className="a" href={buttonText.url} >{buttonText.endBtn2}</a> </h1>


    let startQuizBtn = <div > <button className='btn-play' onClick={() => { this.setState({ quizVisible: !this.state.quizVisible, startQuiz: !this.state.startQuiz }); }} > {this.props.params.buttontext[0].introBtn}</button> </div>

    return (
      // <div className='app' >
      //   <div className='quiz'>
      //     {/* {!this.state.quizVisible ? startQuizBtn : <Quiz questions={questions} params={params} />

      //     } */}
      //   </div>
      <div className="asd">
        <div className='banner'>
          <div className='banner-title'>{params.buttontext[0].bannerTitle}</div>
          <div className='banner-text'>
            {params.buttontext[0].bannerText}
          </div>
          <div className='quiz'>
            {!this.state.quizVisible ? startQuizBtn : <Quiz questions={questions} params={params} />}
          </div>
          {/* <button onClick={() => window.location.href = '#myportfolios&newstrategy'} className='banner-button'>START </button> */}
        </div>
      </div>


      // </div >
    )
  }


}

export default (App);